import {FC, Suspense} from 'react';
import {Navigate, Route, Routes} from 'react-router';
import {LoadingScreen} from 'src/components/LoadingScreen';
import {RouteNotFound} from 'src/RoutesManager/RouteNotFound';
import {PrivateRoute} from 'src/components/PrivateRoute';
import {RoutesManagerMain} from 'src/RoutesManager/RoutesManagerMain';
import {AuthCallback, LoginPage} from 'src/pages/LoginPage';
import {
  callbackRoute,
  dashboardRoute,
  loginRoute,
  dashboardRouteFragment,
  mcpAuthorizeRoute,
} from 'src/routes';
import {McpAuthorizePage} from 'src/pages/McpAuthorize/McpAuthorizePage';
import {NoAuthLayout} from 'src/components/MainLayout/NoAuthLayout';

const homeRoute = `${dashboardRoute}/`;

// wrap usages in PrivateRoute, otherwise infinite redirect on login
const NavigateToHome = () => (
  <Navigate
    to={homeRoute}
    replace
  />
)

export const RoutesManager: FC = () => {
  return (
    <Suspense fallback={<LoadingScreen isFullScreen={true} />}>
      <Routes>
        {/* Unauthenticated: signing in, and where a federated sign-in returns. */}
        <Route path={loginRoute} element={<LoginPage />} />
        <Route path={callbackRoute} element={<AuthCallback />} />
        {/* MCP OAuth consent - handles its own sign-in so the */}
        {/* ?request= query survives the sign-in round trip */}
        <Route
          path={mcpAuthorizeRoute}
          element={
            <NoAuthLayout>
              <McpAuthorizePage />
            </NoAuthLayout>
          }
        />
        <Route
          path={`/`}
          element={
            <PrivateRoute
              component={NavigateToHome}
            />
           }
        />
        <Route
          path="/index.html/"
          element={
            <PrivateRoute
              component={NavigateToHome}
            />
           }
        />
        <Route
          path={`/*`}
          element={
            <PrivateRoute
              component={RoutesManagerMain}
            />
          }
        />
        <Route
          path={`${dashboardRouteFragment}/*`}
          element={
            <PrivateRoute
              component={RoutesManagerMain}
            />
          }
        />
        <Route
          path="*"
          element={<>
            <h3>RoutesManager</h3>
            <RouteNotFound path={window.location.pathname} />
          </>}
        />
      </Routes>
    </Suspense>
  );
};
